/**
* Sliderのコンストラクタ
* @constructor
* @param {selector} - el jqueryセレクタ
*/
module.exports = Slider = function(el){
  this.element = $(el);
  this.event();
};

/**
* event
*/
Slider.prototype.event = function(){
  var self = this;
    this.element.slick({
      dots: false,
      slidesToShow: 1,
      arrows: true,
        responsive: [
          {
            breakpoint: 767,
              settings: {
                adaptiveHeight: true
              }
          }
        ]
    });

  //resize
  var timer = false;
  var currentWidth = window.innerWidth;
  $(window).resize(function() {
      if (timer !== false) {
          clearTimeout(timer);
      }
      timer = setTimeout(function() {
        if (currentWidth == window.innerWidth) {
            // ウインドウ横幅が変わっていないため処理をキャンセル。
            return;
        }
        currentWidth = window.innerWidth;
          $('.js-slider').slick('unslick');
          $('.js-slider').slick({
              dots: false,
              slidesToShow: 1,
              arrows: true,
                responsive: [
                  {
                    breakpoint: 767,
                    settings: {
                      adaptiveHeight: true
                    }
                  }
                ]
            })
        console.log("resize!");
      }, 200);
  });

};



//////////////////
// WEBPACK FOOTER
// ./js/_modules/slider.js
// module id = 12
// module chunks = 0